import { Grid, Typography } from "@mui/material";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useGetPurchaseSubCategory } from "./API/api";
import { Card } from "components/ui";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useGlobalContext } from "context/GlobalContext";
import SortContext from "context/SortContext";
import LoadingSmallCard from "components/ui/Skeleton/LoadingSmallCard";

function SubCategoryPurchase({ category }) {
  const [subCategories, setSubCategories] = useState([]);
  const { clientId } = useParams();

  let navigate = useNavigate();
  const { setFilterChangeCount, setDisplayCount, setFilterChangeDesignCount, setSearchResultCount, setSearchSuffix, dynamicfilterCount, filterChangeCount, filterChangeDesignCount } =
    useGlobalContext();
  const { setSortOptions } = useContext(SortContext);

  //API
  const { data, isLoading, error } = useGetPurchaseSubCategory({
    clientCode: clientId,
    categoryName: category,
  });

  useEffect(() => {
    if (data) {
      setSubCategories(data.data);
    }
  }, [data]);

  useEffect(() => {
    if (dynamicfilterCount) {
      setFilterChangeCount(data?.totalCount);
      setSearchResultCount(0);
    } else {
      setSearchResultCount(0);
      setFilterChangeCount(filterChangeCount);
    }

    setDisplayCount(true);
    setSearchSuffix("");

    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      setFilterChangeDesignCount(0);
      setDisplayCount(false);
      setSearchSuffix("");
    };
  }, [subCategories]);

  const handleSubCategoryClick = (subCategoryName) => {
    navigate(`${encodeURIComponent(subCategoryName)}`);
  };

  useEffect(() => {
    setSortOptions(["d", "e", "f"]);
    return () => {
      setSortOptions([]);
    };
  }, []);

  if (isLoading) {
    return <LoadingSmallCard count={20} />;
  }

  if (error) {
    return <p>Error found</p>;
  }

  return (
    <div style={{ color: "yellow" }}>
      <Grid container className="Grid-padding" direction="row" sx={{ flex: "1 1 1", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "30px", rowGap: "32px" }}>
        {subCategories?.map((category) => {
          return (
            <Grid item onClick={() => handleSubCategoryClick(category?.subCategoryName)}>
              <Card
                style={{
                  minWidth: "290px",
                  maxWidth: "290px",
                  height: 62,
                  borderRadius: "5px",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <Typography mr={"auto"} fontSize={"20px"} fontWeight={400} fontFamily={"Karla"}>
                  {category.subCategoryName}
                </Typography>
                <Typography ml={"auto"} fontSize={"20px"} fontWeight={400} fontFamily={"Karla"}>
                  {category.count}
                </Typography>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
}

export default SubCategoryPurchase;
